import {
  DetailedHTMLProps,
  FC,
  TextareaHTMLAttributes,
  forwardRef,
} from "react";
import styles from "./FormFields.module.scss";

type Props = DetailedHTMLProps<
  TextareaHTMLAttributes<HTMLTextAreaElement>,
  HTMLTextAreaElement
>;

const TextArea: FC<Props> = forwardRef((props, ref) => (
  <div className={styles.field}>
    <textarea {...props} ref={ref} id={props.name} />
  </div>
));

TextArea.displayName = "TextArea";

export default TextArea;
